export enum SEMANTIC_EVENT_NAME {
  ApplyNow = 'apply_now',
  InteractMessages = 'interact_messages',
  ReplyMessage = 'reply_message',
  ReportConversation = 'report_conversation',
  ViewContent = 'view_content',
  ViewInbox = 'view_inbox',
  ViewMessage = 'view_message',
}

export enum TOPIC_TAG_TXT {
  RachelSatellite = 'rachel_satellite',
}

export enum TRIGGER_TYPE {
  Impression = 'impression',
  Interaction = 'interaction',
  View = 'view',
}

export enum TRIGGER_LOCATION {
  RachelInbox = 'rachel_inbox',
}

export enum TRIGGER_SOURCE {
  RachelInbox = 'rachel_inbox',
  ViewAttachmentModal = 'view_attachment_modal',
}

export enum TRIGGER_OBJECT {
  NoTriggerObject = 'no_trigger_object',
}
